var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgNotifTimes = function SvgNotifTimes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.992 18.869c-7.048 6.63-3.736 6.91-10.723.25-.358-.36-.359-.874 0-1.232.638-.64 1.278-1.277 1.917-1.915.99-.998 1.992-1.975 2.975-2.98-1.665-1.558-3.237-3.244-4.87-4.844a.851.851 0 01-.058-1.22c1.588-1.571 3.148-3.175 4.752-4.73.948-.718 1.662.706 2.311 1.22 1.24 1.24 2.457 2.488 3.714 3.711 7.057-6.512 3.68-6.957 10.716-.22.565.566.077 1.195-.404 1.607-1.5 1.49-2.955 3.017-4.484 4.478 1.62 1.638 3.25 3.26 4.875 4.894.278.278.364.6.214.968-.471.69-1.177 1.211-1.74 1.83-5.049 4.9-2.528 4.424-9.195-1.817z",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  })));
};
export default SvgNotifTimes;